import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import DoneOutline from "@material-ui/icons/DoneOutline";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import servicesStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/servicesStyle.jsx";

function SectionServices(props) {
  const { classes } = props;
  return (
    <div className={classes.services}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
        >
          <h2 className={classes.title}>Five considerations for creating a family office</h2>
          <h5 className={classes.description}>
            Because of the growing complexity of managing, protecting and growing family wealth, family offices have evolved to address new challenges and needs:
          </h5>


        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem md={4} sm={4}>
          <InfoArea
            title="FIRST"
            description={
              <span>
                <p>
                  <ul>
                  <li>Protecting family wealth by ensuring it is structured in compliance with relevant legislation and regulation requirements</li>
                  <li>Global wealth management for high net-worth clients</li>
                  <li>Expand your family wealth horizon.</li>
                  </ul>
                  Family wealth at all levels needs to be efficiently organised for good management, tax efficiency and future planning.
                  Family wealth management is a process built around the coupling of financial planning and asset management.
                  We view the two as inseparable components of a long-term successful strategy.
                  At Kinos, each family we work with is unique, as their goals are defined by their life experiences and family circumstances.
                </p>
                
              </span>
            }
            icon={DoneOutline}
            iconColor="green"
          />
        </GridItem>
        <GridItem md={4} sm={4}>
          <InfoArea
            title="SECOND"
            description={
              <span>
                <p>
                  Spreading investment risk by diversifying family wealth
We help you to develop the right financial plan and corresponding investment strategies to achieve your goals.
Diversifying – the smart way to save and invest diversification
 – spreading your money between different kinds of investments (called ‘asset classes’) and different kinds of investment product – helps reduce the risk of your overall investments (referred to as your ‘portfolio’) under-performing or losing money.
 “Fortunes are made through concentration and are kept through diversification,” goes an old family business adage.
                </p>
                
              </span>
            }
            icon={DoneOutline}
            iconColor="success"
          />
        </GridItem>
        <GridItem md={4} sm={4}>
          <InfoArea
            title="THIRD"
            description={
              <span>
                <p>
                  Improving family cohesion and generational transition by enabling debate within the family about strategic asset allocation and key investment decisions.
                  Positioning of our target strategic allocation of financial assets in relation to the range of possible portfolios.
                  The relationship between an ultra-high net worth family and its single family office is a complex partnership that must survive many phases, transitions, and challenges.
                  One way to understand family offices is to observe their evolution across generations as they connect disparate family members and manage complex investments.
                </p>
                
              </span>
            }
            icon={DoneOutline}
            iconColor="info"
          />
        </GridItem>

        <GridItem md={6} sm={6}>
          <InfoArea
            title="FOURTH"
            description={
              <span>
                <p>
                  Clarifying governance over how the family stewards its wealth by establishing proper processes to manage the assets.
                  The family office represents a collaborative alliance among three groups of stakeholders: the elder and younger family generations and the professionals who run the office.
                  Successful long-term development rests on effective collaboration across these groups.
                  Elder generations set a foundation of legacy values and practices for the family, together with leadership, mentoring, and stability.
                  They must nevertheless transfer power over time to their maturing adult children and to their non-family advisors.
                </p>
                
              </span>
            }
            icon={DoneOutline}
            iconColor="danger"
          />
        </GridItem>

        <GridItem md={6} sm={6}>
          <InfoArea
            title="FIFTH"
            description={
              <span>
                <p>
                  Strategic Governance, for decision making. Every organisation, from single family offices to multinational businesses.
                  <ul>
                    <li>It promotes the shared purpose of the family and helps the office to achieve the family’s vision of success.</li>
                    <li>It can be scaled up or down in line with the complexity of the family, the assets, the clients and the services;</li>
                    <li>It creates accountability and so ensures that the family office abides by relevant laws and regulations;</li>
                    <li>The governance structure helps to manage risk and complexity while promoting efficient decision-making and transparency;</li>
                    <li>The structure operates as designed even in times of extreme stress and conflict.</li>
                  </ul>
                </p>
                
              </span>
            }
            icon={DoneOutline}
            iconColor="warning"
          />
        </GridItem>


      </GridContainer>
    </div>
  );
}



export default withStyles(servicesStyle)(SectionServices);
